import PropTypes from 'prop-types';
import { motion } from 'framer-motion';

/**
 * NavMotion component is used to animate the content.
 * 
 * @param {Object} props - The component props.
 * @param {ReactNode} props.children - The child components.
 * @return {ReactElement} The rendered NavMotion component.
 */
const NavMotion = ({ children }) => {
    /**
     * Motion variants for animation
     */
    const motionVariants = {
        initial: {
            opacity: 0,
            scale: 0.99
        },
        in: {
            opacity: 1,
            scale: 1
        },
        out: {
            opacity: 0,
            scale: 1.01
        }
    };

    /**
     * Motion transition configuration
     */
    const motionTransition = {
        type: 'tween',
        ease: 'anticipate',
        duration: 0.4
    };

    /**
     * Renders the NavMotion component with animation
     */
    return (
        <motion.div initial="initial" animate="in" exit="out" variants={motionVariants} transition={motionTransition}>
            {children}
        </motion.div>
    );
};

/**
 * PropTypes for NavMotion component
 */
NavMotion.propTypes = {
    children: PropTypes.node
};

export default NavMotion;
